export default "__VITE_ASSET__CpROamYp__"